import { render, staticRenderFns } from "./Select2Ajax.vue?vue&type=template&id=2d2a70a4"
import script from "./Select2Ajax.vue?vue&type=script&lang=js"
export * from "./Select2Ajax.vue?vue&type=script&lang=js"
import style0 from "./Select2Ajax.vue?vue&type=style&index=0&id=2d2a70a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports